export default class AdminPaqueteForm {
    /**
     * 
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: 'Nuevo paquete',
            method: 'POST',
            url: '/api/admin/paquetes'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        let data = {
            nombre: '', nombre_publico: '', prefijo: ''
        };
        this.modal.render(this.render(data));
    }

    /**
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(id, options) {
        let myself = this;
        let modalOpts = {
            title: 'Editar paquete',
            method: 'PUT',
            url: `/api/admin/paquetes/${id}`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/paquetes/${id}`, {
            then: function (response) {
                myself.modal.render(myself.render(response.data));
            }
        });
    }

    render(data) {
        let txtPrefijo;
        if (data.nombre != '') {
            txtPrefijo = data.prefijo;
        } else {
            txtPrefijo = `<input type="text" value="${data.prefijo}" id="prefijo" name="prefijo" maxlength="10" class="form-control" required/>`;
        }
        return `<form>
        <div class="row form-group">
            <label for="nombre" class="col-form-label col col-md-4">Nombre</label>
            <div class="col col-md-8">
                <input type="text" value="${data.nombre}" id="nombre" name="nombre" maxlength="250" class="form-control" required/>
            </div>
        </div>
        <div class="row form-group">
            <label for="prefijo" class="col-form-label col col-md-4">Prefijo</label>
            <div class="col col-md-8">${txtPrefijo}</div>
        </div>
        <div class="row form-group">
            <label for="nombre_publico" class="col-form-label col col-md-4">Nombre público</label>
            <div class="col col-md-8">
                <input type="text" value="${data.nombre_publico}" id="nombre_publico" name="nombre_publico" maxlenght="250" class="form-control" required/>
            </div>
        </div>
        </form>`;
    }
}